import * as React from "react";
export class EventText extends React.PureComponent<{
    text?: string,
    modifier?: Array<string>
}, {}> {

    render() {
        let clsMdf = "";
        this.props.modifier && this.props.modifier.forEach(mdf => {
            clsMdf += " rj-superbanner__event-text--" + mdf;
        })

        let dataUat = "superbanner-event-text";
        this.props.modifier ? this.props.modifier.forEach(mdf => {
            dataUat += `-${mdf}`;
        }) : dataUat;
        return (
            <div className={`rj-superbanner__event-text${clsMdf}`} data-uat={dataUat}>{this.props.text}</div>
        )
    }
}